export default {
  path: 'winter-service/report',
  name: 'RoadMaintenanceReport',
  props: true,
  component: () => import(/* webpackChunkName: "satellite-tracking" */ '../views/ReportIndex.vue')
}
